module.exports = __webpack_public_path__ + "img/home-icon-active.a23789d2.svg";